module.exports = __webpack_public_path__ + "static/5-7bd15bd325e8b43ad60f08e46a586688.jpg";